export default {"src":"/hedera/_next/static/media/link.83acf59a.svg","height":12,"width":13};